/**
 * Prins: Config
 *
 * @copyright 2023 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {extend} from '@ifabnpm/bootstrap/utils.js';

import configClient from '../../client/config/config';

// -------
// Private
// -------

// Icons
const icons = {
	calendarCheck : '<i aria-hidden="true" class="fa-regular fa-calendar-check" data-icon></i>',
	clock         : '<i aria-hidden="true" class="fa-solid fa-clock" data-icon></i>',
	close         : '<i aria-hidden="true" class="fa-solid fa-times" data-icon></i>',
	danger        : '<i aria-hidden="true" class="fa-regular fa-triangle-exclamation" data-icon></i>',
	edit          : '<i aria-hidden="true" class="fa-solid fa-pen" data-icon></i>',
	info          : '<i aria-hidden="true" class="fa-regular fa-circle-info" data-icon></i>',
	move          : '<i aria-hidden="true" class="fa-solid fa-up-down-left-right" data-icon></i>',
	moveHorizontal: '<i aria-hidden="true" class="fa-solid fa-left-right" data-icon></i>',
	moveVertical  : '<i aria-hidden="true" class="fa-solid fa-up-down" data-icon></i>',
	next          : '<i aria-hidden="true" class="fa-solid fa-chevron-right" data-icon></i>',
	prev          : '<i aria-hidden="true" class="fa-solid fa-chevron-left" data-icon></i>',
	remove        : '<i aria-hidden="true" class="fa-solid fa-trash-can" data-icon></i>',
	scrollTop     : '<i aria-hidden="true" class="fa-solid fa-arrow-up" data-icon></i>',
	success       : '<i aria-hidden="true" class="fa-regular fa-circle-check" data-icon></i>',
	warning       : '<i aria-hidden="true" class="fa-regular fa-hexagon-exclamation" data-icon></i>'
};

// ------
// Public
// ------

// Export
export default extend({}, {
	icons
}, configClient);
